import React from 'react';
import { Button as MuiButton } from 'new/elements/Button';
import { buttonClasses, ButtonProps, styled } from '@mui/material';

const muiStyles = {
  primary: {
    root: {
      backgroundColor: '#357BFF',
      color: '#fff',
      minWidth: 90,
      height: 32,
      borderRadius: 2,
      marginRight: 10,
      '&:hover': {
        backgroundColor: '#1e65eb',
      },
      '&:disabled': {
        color: '#fff',
      },
    },
    label: {
      fontSize: 12,
      fontWeight: 500,
      letterSpacing: 1,
    },
  },
  secondary: {
    root: {
      backgroundColor: '#4AD496',
      color: '#fff',
      minWidth: 90,
      height: 32,
      borderRadius: 2,
      marginRight: 10,
      '&:hover': {
        backgroundColor: '#38B57D',
      },
      '&:disabled': {
        color: '#fff',
      },
    },
    label: {
      fontSize: 12,
      fontWeight: 500,
      letterSpacing: 1,
    },
  },
  cancel: {
    root: {
      backgroundColor: '#F4F5F7',
      color: '#000c',
      minWidth: 90,
      height: 32,
      borderRadius: 2,
      marginRight: 10,
      '&:hover': {
        backgroundColor: '#F7F9FA',
      },
      '&:disabled': {
        color: '#000c',
      },
    },
    label: {
      fontSize: 12,
      fontWeight: 500,
      letterSpacing: 1,
    },
  },
  delete: {
    root: {
      backgroundColor: 'rgba(217, 31, 32, 1)',
      color: '#fff',
      minWidth: 90,
      height: 32,
      borderRadius: 2,
      marginRight: 10,
      '&:hover': {
        backgroundColor: 'rgba(217, 31, 32,0.75)',
      },
      '&:disabled': {
        color: '#fff',
      },
    },
    label: {
      fontSize: 12,
      fontWeight: 500,
      letterSpacing: 1,
    },
  },
  brand: {
    root: {
      backgroundColor: '#FF7436',
      color: '#fff',
      minWidth: 90,
      height: 32,
      borderRadius: 2,
      marginRight: 10,
      '&:hover': {
        backgroundColor: '#D6632D',
      },
      '&:disabled': {
        color: '#fff',
      },
    },
    label: {
      fontSize: 12,
      fontWeight: 500,
      letterSpacing: 1,
    },
  },
  dark: {
    root: {
      backgroundColor: '#2A3F56',
      color: '#fff',
      minWidth: 90,
      height: 32,
      borderRadius: 2,
      marginRight: 10,
      '&:hover': {
        backgroundColor: '#3E5D7F',
      },
      '&:disabled': {
        color: '#fff',
      },
    },
    label: {
      fontSize: 12,
      fontWeight: 500,
      letterSpacing: 1,
    },
  },
};

const StyledButtonBrand = styled(MuiButton)(() => ({
  ...muiStyles.brand.root,
  [`& .${buttonClasses.text}`]: muiStyles.brand.label,
}));
const StyledButtonDark = styled(MuiButton)(() => ({
  ...muiStyles.dark.root,
  [`& .${buttonClasses.text}`]: {
    fontSize: 12,
    fontWeight: 500,
    letterSpacing: 1,
  },
}));

function Button({
  buttonTheme = 'default',
  variant = 'contained',
  rootStyle = {},
  children,
  ...otherProps
}: ButtonProps & {
  rootStyle?: any;
  buttonTheme?: string;
}) {
  ((otherProps as any) || {}).variant = variant;

  let buttonElement = null;

  switch (buttonTheme) {
    case 'secondary':
      buttonElement = (
        <MuiButton color="secondary" style={rootStyle} {...otherProps}>
          {children}
        </MuiButton>
      );
      break;

    case 'cancel':
      buttonElement = (
        <MuiButton color="inherit" style={rootStyle} {...otherProps}>
          {children}
        </MuiButton>
      );
      break;

    case 'delete':
      buttonElement = (
        <MuiButton color="error" style={rootStyle} {...otherProps}>
          {children}
        </MuiButton>
      );
      break;

    case 'brand':
      buttonElement = (
        <StyledButtonBrand style={rootStyle} {...otherProps}>
          {children}
        </StyledButtonBrand>
      );
      break;

    case 'dark':
      buttonElement = (
        <StyledButtonDark style={rootStyle} {...otherProps}>
          {children}
        </StyledButtonDark>
      );
      break;

    case 'primary':
      buttonElement = (
        <MuiButton color="primary" style={rootStyle} {...otherProps}>
          {children}
        </MuiButton>
      );
      break;

    case 'default':
    default:
      buttonElement = (
        <MuiButton style={rootStyle} {...otherProps}>
          {children}
        </MuiButton>
      );
      break;
  }

  return buttonElement;
}

export default Button;
